module.exports = __webpack_public_path__ + "static/media/twitter.797e3172.svg";